import { render, staticRenderFns } from "./IconContent.vue?vue&type=template&id=ffb0b9c6&functional=true"
import script from "./IconContent.vue?vue&type=script&lang=js"
export * from "./IconContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports